module.exports = __webpack_public_path__ + "static/media/mockupui wedp.541a4d37.webp";